module.exports = __webpack_public_path__ + "img/wifiw.d9f5d3b7.png";